import { Injectable, OnDestroy } from '@angular/core';
import { Stores } from 'services/definition/stores';
import { Environment } from 'src/environments/environment';
import { IndexDB } from './class/indexdb';

@Injectable({
  providedIn: 'root'
})
export class IndexDbService extends IndexDB implements OnDestroy {
  constructor() {
    super(window.indexedDB, Environment.DatabaseName, Stores, "IndexDbService")
  }
  ngOnDestroy(): void {
    this.close()
  }
}
